import http from "../http-common";

class UploadFilesService {
    upload(file, fileType, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);
        let convert_url = "/convert/auxi_upload"
        if (fileType === "anim")
            convert_url = "/convert/anim_upload"
        if (fileType === "amft")
            convert_url = "/convert/amft_upload"
        if (fileType === "small")
            convert_url = "/convert/small_upload"
        if (fileType === "corsa")
            convert_url = "/convert/corsa_upload"
        if (fileType === "asts")
            convert_url = "/convert/asts_upload"
        if (fileType === "abkg")
            convert_url = "/convert/abkg_upload"
        if (fileType === "abkg_big")
            convert_url = "/convert/abkg_big_upload"
        if (fileType === "arga")
            convert_url = "/convert/arga_upload"

        return http.post(convert_url, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
        onUploadProgress
        });
    }

    getFiles(fileType) {
        if (fileType==="anim")
            return http.get("/convert/anim_files")
        if (fileType==="auxi")
            return http.get("/convert/auxi_files")
        if (fileType==="amft")
            return http.get("/convert/amft_files")
        if (fileType==="small")
            return http.get("/convert/small_files")
        if (fileType==="corsa")
            return http.get("/convert/corsa_files")
        if (fileType==="asts")
            return http.get("/convert/asts_files")
        if (fileType==="abkg")
            return http.get("/convert/abkg_files")
        if (fileType==="abkg_big")
            return http.get("/convert/abkg_big_files")
        if (fileType==="arga")
            return http.get("/convert/arga_files")
    }
}

export default new UploadFilesService();